import React, { useEffect } from "react";
import styled from "styled-components";
import Modal from "../Kanban/Modal/Modal";
import { useFormikContext } from "formik";
import { useLanguage } from "../LangTranslation/LanguageContext";
import { primaryColor } from "../../utilities/colors";

const ActionButton = styled.button`
  border-radius: 10px;
  background-color: ${(props) =>
    props["data-isvtex"] ? "#000000" : "#ff5837"};
  color: ${(props) => (props["data-isvtex"] ? primaryColor.primary : "#fff")};
  font-family: "Inter";
  border: none;
  min-width: 90px;
  height: 35px;
  margin-right: 20px;
`;

function PaletteEditor({
  disabled,
  isModalOpen,
  setIsModalOpen,
  palette,
  setPalette,
}) {
  const { language, translations } = useLanguage();
  const t = translations[language];
  const { setFieldValue } = useFormikContext();

  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);

  const handleCustomColorChange = (index, color) => {
    setPalette((prevColors) => {
      const updatedColors = [...prevColors];
      updatedColors[index] = { ...updatedColors[index], hex: color };
      return updatedColors;
    });
  };

  const handleSaveAndClose = () => {
    // Update form field value on save
    setFieldValue("website_palette", JSON.stringify(palette));
    closeModal();
  };

  useEffect(() => {
    if (isModalOpen) {
      // optional: handle anything when modal opens
    }
  }, [isModalOpen]);

  return (
    <div className="my-3 d-flex justify-content-center align-items-center">
      <a
        className="m-0 p-0"
        type="button"
        onClick={(e) => {
          if (disabled) {
            e.preventDefault();
            e.stopPropagation();
            return;
          }
          openModal();
        }}
        style={{
          fontFamily: "Comfortaa",
          color: primaryColor.primary,
          cursor: "pointer",
          textDecoration: "underline",
        }}
      >
        Palette Editor
      </a>

      <Modal isOpen={isModalOpen} onClose={closeModal}>
        <div className="modal-header">
          <h5 className="modal-title">Edit Palette Colors</h5>
          <button
            type="button"
            className="ms-2 btn-close"
            onClick={closeModal}
          ></button>
        </div>

        <div className="modal-body">
          <div className="palette-wrapper d-flex gap-2 flex-wrap">
            {palette?.map((color, index) => (
              <input
                key={index}
                type="color"
                value={color.hex}
                onChange={(e) => handleCustomColorChange(index, e.target.value)}
                style={{
                  width: "30px",
                  height: "30px",
                  border: "1px solid #000",
                  borderRadius: "4px",
                  padding: "0px",
                  cursor: "pointer",
                }}
              />
            ))}
          </div>
        </div>

        <div className="modal-footer d-flex justify-content-center">
          <ActionButton type="button" onClick={handleSaveAndClose}>
            {t["Save & Close"]}
          </ActionButton>

          <ActionButton type="button" onClick={closeModal}>
            {t["Discard"]}
          </ActionButton>
        </div>
      </Modal>
    </div>
  );
}

export default PaletteEditor;
